<template>
	<div class="common_layout user_layout">
		<div class="flexRow" style="margin-top: 41px">
			<img style="width: 104px; height: 86.63px" src="../../assets/images/JJ_laugh.png" />
		</div>
		<div class="topTitle">谢谢！您已完成购买！</div>
		<!-- <p class="common_font" style="color: #FF4545; font-weight: normal; text-align: center;">预购商品预计11月初陆续发货</p> -->

		<div class="secondTitle">您可复制或截图订单号作为购买依据</div>
		<div class="thirdTitle">
			订单号：{{ orderNo }}
			<img
				@click="copyText"
				style="width: 16px; height: 16px; marginleft: 10px"
				src="../../assets/images/copy.png"
			/>
		</div>

		<div style="margin-top: 10px">
			<a href="tel:400-920-3970">
				<p class="common_font" style="padding: 5px 0; font-size: 12px; text-align: center">
					客服电话:400-920-3970
				</p>
			</a>
			<p class="common_font" style="padding: 0; margin: 0; font-size: 12px; text-align: center">
				客服邮箱:service@orota.cn
			</p>
			<p class="common_font" style="margin: 5px 0; font-size: 12px; text-align: center">
				(工作日10点至18点整)
			</p>
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance();
onMounted(() => {
	orderNo.value = router.currentRoute.value.query.orderNo;
});
const orderNo = ref("");
const copyText = () => {
	const textArea = document.createElement("textarea");
	textArea.value = orderNo.value;
	// 将 textarea 元素添加到 DOM 中
	document.body.appendChild(textArea);
	// 选中文本
	textArea.select();
	// 执行复制命令
	document.execCommand("copy");
	// 移除 textarea 元素
	document.body.removeChild(textArea);
	proxy.$toast("复制成功");
};
</script>

<style lang="less" scoped>
.user_layout {
	background-color: rgba(244, 243, 248, 1);
	min-height: 100vh;
}
.flexRow {
	display: flex;
	align-items: center;
	justify-content: center;
}
.topTitle {
	color: rgba(119, 90, 204, 1);
	margin-top: 30px;
	text-align: center;
	font-size: 20px;
	font-weight: 500;
}
.secondTitle {
	color: rgba(119, 90, 204, 1);
	margin-top: 60px;
	text-align: center;
	font-weight: 400;
	color: #000000;
	opacity: 0.7;
	font-size: 14px;
	margin-top: 60px;
}
.thirdTitle {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	font-weight: 400;
	color: #000000;
	margin-top: 15px;
	text-align: center;
}
</style>
